import { CategoryResponseModel } from '../types/Profile';

export const LANGUAGES = [
  { id: 1, name: 'English' },
  { id: 2, name: 'French' },
  { id: 3, name: 'German' },
  { id: 4, name: 'Spanish' },
  { id: 5, name: 'Chinese' },
  { id: 6, name: 'Japanese' },
  { id: 7, name: 'Korean' },
  { id: 8, name: 'Russian' },
  { id: 9, name: 'Portuguese' },
  { id: 10, name: 'Italian' },
  { id: 11, name: 'Dutch' },
  { id: 12, name: 'Arabic' },
  { id: 13, name: 'Hindi' },
  { id: 14, name: 'Bengali' },
  { id: 15, name: 'Punjabi' },
  { id: 16, name: 'Javanese' },
  { id: 17, name: 'Vietnamese' },
  { id: 18, name: 'Urdu' },
  { id: 19, name: 'Persian' },
  { id: 20, name: 'Turkish' },
];

const categoryDefinitions: CategoryResponseModel[] = [
  { id: 1, name: 'Activism & Social Causes' },
  { id: 2, name: 'Art & Design' },
  { id: 3, name: 'Automotive' },
  { id: 4, name: 'Beauty & Makeup' },
  { id: 5, name: 'Books & Literature' },
  { id: 6, name: 'Business & Entrepreneurship' },
  { id: 7, name: 'Comedy & Entertainment' },
  { id: 8, name: 'DIY & Crafts' },
  { id: 9, name: 'Education & Learning' },
  { id: 10, name: 'Events & Social Gatherings' },
  { id: 11, name: 'Fashion & Style' },
  { id: 12, name: 'Finance & Investing' },
  { id: 13, name: 'Fitness & Health' },
  { id: 14, name: 'Food & Cooking' },
  { id: 15, name: 'Gaming' },
  { id: 16, name: 'History & Culture' },
  { id: 17, name: 'Home Decor & Interior Design' },
  { id: 18, name: 'Lifestyle' },
  { id: 19, name: 'Motivational & Self-improvement' },
  { id: 20, name: 'Music' },
  { id: 21, name: 'Parenting & Family' },
  { id: 22, name: 'Pets & Animals' },
  { id: 23, name: 'Photography & Videography' },
  { id: 24, name: 'Science & Technology' },
  { id: 25, name: 'Spirituality & Mindfulness' },
  { id: 26, name: 'Sports & Outdoor Activities' },
  { id: 27, name: 'Sustainable Living & Eco-friendly Practices' },
  { id: 28, name: 'Technology & Gadgets' },
  { id: 29, name: 'Travel & Adventure' },
  { id: 30, name: 'TV & Film' },
  { id: 31, name: 'AI' },
];

export const CATEGORIES: CategoryResponseModel[] = [...categoryDefinitions].sort(
  (a, b) => a.name.localeCompare(b.name)
);
